import { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { RiFileCopyLine } from "react-icons/ri";
import { toast } from "react-toastify";
import { withNamespaces } from "react-i18next";

const GeojsonViewerButton = ({ t, geojsonData }) => {
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);

    const toggle = () => {
        setOpen(!open);
        if (!open) setCopied(false); 
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(JSON.stringify(geojsonData, null, 2))
            .then(() => {
                setCopied(true);

                setTimeout(() => {
                    setCopied(false);
                }, 1500);
            })
            .catch(() => {
                toast(t('Failed to copy to clipboard'), {
                    type: 'error'
                });
            });
    };

    return (
        <>
            <Button color="secondary" outline className="align-self-end" onClick={toggle}>
                {t('View GeoJSON')}
            </Button>

            <Modal isOpen={open} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>
                    {t('GeoJSON Data')}
                </ModalHeader>
                <ModalBody>
                    <pre style={{ maxHeight: "400px", overflowY: "auto" }}>
                        {JSON.stringify(geojsonData, null, 2)}
                    </pre>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-between">
                    <Button color="primary" onClick={handleCopy}>
                        <RiFileCopyLine className="me-1" />
                        {t(copied ? "Copied!" : "Copy to Clipboard")}
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        {t('Close')}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default withNamespaces()(
    GeojsonViewerButton
);
